import { ReactElement } from 'react';
import { useSelector } from 'react-redux';

import {
  selectAuthRegion,
  selectIsLoggedIn
} from 'features/auth/authSelectors';

import { Region } from 'constants/enums';

import { useTranslation } from 'react-i18next';
import styles from './RegionLabel.module.scss';

const RegionLabel = (): ReactElement | null => {
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const region = useSelector(selectAuthRegion);
  const { t } = useTranslation()

  if (!isLoggedIn) {
    return null;
  }

  let regionLabel;

  switch (region) {
    case Region.US:
      regionLabel = t('common.label.region.US');
      break;
    case Region.EU:
      regionLabel = t('common.label.region.europe');
      break;
    default:
      regionLabel = t('common.label.region.notDefined');
  }

  return <div className={styles.regionLabel}>{regionLabel}</div>;
};

export default RegionLabel;
